import styled from "styled-components";

export const Container = styled.div`
    box-sizing: border;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-bottom: 2px solid #ffc971;
    margin-bottom: 20px;
    padding: 10px;

`;

export const Title = styled.h1`
    font-weight: bold;
    color: #cc5803;
    margin: 0;
    padding: 0;
`;

export const SubTitle = styled.h3`
    font-weight: bold;
    color: #ff9505;
    margin: 0;
    margin-bottom: 10px;

`; 
